import type { SeparacionEstado } from '../../types/consultas';

/**
 * Estados de una separación como constantes de dominio (AGENTS §23; requisitos «Flujo 3»).
 * El orden sigue el ciclo de vida: Borrador → Generada ⇄ Corregida → Anulada / Descartada.
 */
export const SEPARACION_ESTADOS: ReadonlyArray<{ valor: SeparacionEstado; etiqueta: string }> = [
  { valor: 'BORRADOR', etiqueta: 'Borrador' },
  { valor: 'GENERADA', etiqueta: 'Generada' },
  { valor: 'CORREGIDA', etiqueta: 'Corregida' },
  { valor: 'ANULADA', etiqueta: 'Anulada' },
  { valor: 'DESCARTADA', etiqueta: 'Descartada' },
];

export const ESTADO_GENERADA: SeparacionEstado = 'GENERADA';
export const ESTADO_CORREGIDA: SeparacionEstado = 'CORREGIDA';
export const ESTADO_BORRADOR: SeparacionEstado = 'BORRADOR';
export const ESTADO_ANULADA: SeparacionEstado = 'ANULADA';
export const ESTADO_DESCARTADA: SeparacionEstado = 'DESCARTADA';
/** feat-67: estados desde los que se puede anular (el back valida la misma matriz). */
export const ESTADOS_ANULABLES: readonly SeparacionEstado[] = ['GENERADA', 'CORREGIDA'];

/** feat-67 · S-4: reglas del motivo de anulación (el back las repite). */
export const MOTIVO_ANULACION_MIN = 10;
export const MOTIVO_ANULACION_MAX = 500;
